export default __webpack_public_path__ + "static/media/image3.46589233.jpeg";